export default {"src":"/_next/static/media/tokko.2a74505c.svg","height":27,"width":121,"blurWidth":0,"blurHeight":0};